import { db } from '../services/firebase';
import { collection, getDocs, updateDoc, doc } from 'firebase/firestore';

// Sensible defaults
const DEFAULT_BRANCH = 'al_wakra';
const DEFAULT_PAR_LEVEL = 10;
const DEFAULT_ON_HAND = 0;

// Optionally, set per-category par levels
const CATEGORY_PAR_LEVELS = {
  Coffee: 10,
  Dairy: 6,
  Supplies: 50,
  Syrups: 4,
};

/**
 * Audit and optionally fix missing fields in inventoryItems.
 * @param {Object} opts
 * @param {boolean} opts.dryRun - If true, only logs what would be changed. If false, updates Firestore.
 */
export async function auditInventoryItems({ dryRun = true } = {}) {
  console.log(`\n=== Inventory Items Data Audit (dryRun: ${dryRun}) ===`);
  const snap = await getDocs(collection(db, 'inventoryItems'));
  const items = snap.docs.map(docSnap => ({ id: docSnap.id, ...docSnap.data() }));

  let missingOnHand = [];
  let missingParLevel = [];
  let missingBranch = [];
  let updates = [];

  items.forEach(item => {
    const update = {};
    if (item.on_hand === undefined || item.on_hand === null) {
      missingOnHand.push(item);
      update.on_hand = DEFAULT_ON_HAND;
    }
    if (item.par_level === undefined || item.par_level === null) {
      missingParLevel.push(item);
      // Use category-based default if available
      update.par_level = CATEGORY_PAR_LEVELS[item.category] || DEFAULT_PAR_LEVEL;
    }
    if (!item.branch) {
      missingBranch.push(item);
      update.branch = DEFAULT_BRANCH;
    }
    if (Object.keys(update).length > 0) {
      updates.push({ id: item.id, update, name: item.name });
    }
  });

  // Print summary
  console.log(`\nTotal inventory items: ${items.length}`);
  console.log(`Missing on_hand: ${missingOnHand.length}`);
  console.log(`Missing par_level: ${missingParLevel.length}`);
  console.log(`Missing branch: ${missingBranch.length}`);
  console.log(`\nSample of items needing update:`);
  updates.slice(0, 5).forEach(u => {
    console.log(`- ${u.name || u.id}:`, u.update);
  });
  if (updates.length > 5) {
    console.log(`...and ${updates.length - 5} more.`);
  }

  if (!dryRun && updates.length > 0) {
    console.log(`\nApplying updates to Firestore...`);
    for (const u of updates) {
      await updateDoc(doc(db, 'inventoryItems', u.id), u.update);
      console.log(`Updated ${u.name || u.id}:`, u.update);
    }
    console.log('✅ All updates applied.');
  } else if (dryRun) {
    console.log('\n(DRY RUN: No changes made to Firestore)');
  }

  return {
    total: items.length,
    missingOnHand: missingOnHand.length,
    missingParLevel: missingParLevel.length,
    missingBranch: missingBranch.length,
    updates: updates.length,
  };
}

// To run: import and call auditInventoryItems({ dryRun: true }) from a script or dev console. 